import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { Option } from 'components/atoms/select';
import { BlockSpace } from 'components/atoms/space';
import { Filter } from 'components/molecules/filters/types';
import { Divider } from '../styles';
import { PlaceholderValues } from './placeholder-values';
import { SelectedValues } from './selected-values';
import { ConditionTypes } from './types';

export const Content = ({
  loading,
  contentFor,
  salesforceObject,
  selectedConditions,
  handleModalVisibility,
}: {
  loading?: boolean;
  contentFor: ConditionTypes;
  salesforceObject?: Option;
  selectedConditions?: Filter;
  handleModalVisibility: (visibility: boolean) => void;
}) => {
  switch (true) {
    case Boolean(selectedConditions): {
      if (selectedConditions?.criteria.length) {
        return (
          <BlockSpace direction="vertical" size={16}>
            <SelectedValues
              selectedCondition={selectedConditions}
              showType={contentFor === ConditionTypes.Matches}
              customOptionTrigger={contentFor !== ConditionTypes.Matches}
            />

            <LinkButton
              loading={loading}
              onClick={() => handleModalVisibility(true)}
              disabled={salesforceObject == null}
              type="link"
            >
              <FormattedMessage id="edit" />
              ...
            </LinkButton>
            <Divider />
          </BlockSpace>
        );
      }

      return (
        <PlaceholderValues
          placeholderFor={contentFor}
          disabled={salesforceObject == null}
          onVisibilityChange={handleModalVisibility}
        />
      );
    }

    default: {
      return (
        <PlaceholderValues
          placeholderFor={contentFor}
          disabled={salesforceObject == null}
          onVisibilityChange={handleModalVisibility}
        />
      );
    }
  }
};
